export function setTransform($el, transform) {
    $el.style.transform = transform;
    $el.style.webkitTransform = transform;
}

